import { render } from "./ResultsDuringBuilding.vue?vue&type=template&id=2ed22436"
import script from "./ResultsDuringBuilding.vue?vue&type=script&lang=js"
export * from "./ResultsDuringBuilding.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__